<script lang="ts">
import { defineComponent, useSlots, computed, onMounted } from 'vue'

export default defineComponent({
  name: 'SectionHeadingForContentDetail',

  setup() {
    const slots = useSlots()

    const hasPrimary = computed(() => {
      const v = !!slots.primary && slots.primary().some(vnode => vnode.children || vnode.props)
      if (!v) {
        console.warn('Exception:\nSection heading slot is empty. Please provide content into the slot.')
      }
      return v
    })

    /**
     * @description secondary は任意のスロットなので、空でも警告しない
     *              （両方空の場合のみ onMounted で警告する）
     */
    const hasSecondary = computed(() => {
      return !!slots.secondary && slots.secondary().some(vnode => vnode.children || vnode.props)
    })

    onMounted(() => {
      if (!hasPrimary.value && !hasSecondary.value) {
        console.warn('Exception:\nSection heading slot is empty. Please provide content into the slot.')
      }
    })

    return {
      // computed
      hasPrimary,
      hasSecondary,
    }
  },
})
</script>

<template>
  <div class="o-heading__section">
    <h2 class="o-heading__section--item">
      <span
        v-if="hasPrimary"
        class="o-heading__section--label is-primary">
        <slot name="primary" />
      </span>
      <span
        v-if="hasSecondary"
        class="o-heading__section--label is-secondary">
        <slot name="secondary" />
      </span>
    </h2>
  <!-- /.o-heading__section --></div>
</template>

<style lang="sass" scoped>
// object
.o-heading__section
  margin-bottom: 0.8em

  &:last-child
    margin-bottom: 0

  & &--item
    font-weight: bold

  & &--label
    &.is-primary
      font-size: $font-xx-large

    &.is-secondary
      font-size: $font-normal
</style>
